import React from "react";
import catalogueDE from '../../assets/catalogue-2025-DE.pdf';
import catalogueFR from '../../assets/catalogue-2025-FR.pdf';
import catalogueEN from '../../assets/catalogue-2025-EN.pdf';
import { useTranslation } from "react-i18next";

const DownloadCatalogue = ({ children }) => {
    const { i18n } = useTranslation();
    const catalogue = i18n.language === 'de' ? catalogueDE : i18n.language === 'fr' ? catalogueFR : catalogueEN;

    return(
        <a href={catalogue} target="_blank" rel="noreferrer">
            {children}
        </a>
    )
}
export default DownloadCatalogue;
